import { ServicePathsSettings } from '../../../../core/configuration/service-paths-settings';
import { FascicoloFullResponse } from '../../../models/dto/fascicolo-full-response';
import { FascicoloMap } from '../../../models/fascicolo-map';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { FascicoloLight } from '../../../models/fascicolo/fascicolo-light';
import { fascicoliPCT } from '../../../models/mock/fascicoliPCT';
import { FascicoloPCT } from '../../../models/mock/fascicoloPCT';
import { PraticaBase } from '../../../models/pratica/pratica-base';
import { UtenteLoggato } from '../../../models/utente-loggato';

declare var getFascicoloMapSync;
declare var callServiceSync;
declare var getDominioPctConsultazione;
declare var getDominioPctDeposito;

export class PctUtil {


  static getUrlDepositoPct(fascicolo: FascicoloLight, pratica: PraticaBase, utenteLoggato: UtenteLoggato): string {
  
    return this.getUrlDepositoPctActual(fascicolo,pratica,utenteLoggato,false);
  
  }

  static getUrlDepositoPctActual(fascicolo: FascicoloLight, pratica: PraticaBase, utenteLoggato: UtenteLoggato, tipoProcesso: boolean): string {
    let urlIframe = '';
    let indFasc =  fascicoliPCT.findIndex(f => f.idTipoFascicolo === fascicolo.tipoFascicolo.id && f.idTipoPratica === pratica.tipoPratica.id);
    if (utenteLoggato && indFasc >= 0) {
        let fascicoloPCT: FascicoloPCT = fascicoliPCT[indFasc];
        urlIframe = getDominioPctDeposito() +
        '?TLFUtenteId=' + utenteLoggato.username +
        '&TLFTipoPratica=' + fascicoloPCT.nomePraticaPCT +
        '&TLFTipoFasc=' + fascicoloPCT.nomeFascicoloPCT +
        '&TLFFascId=' + fascicolo.id;
        if(tipoProcesso && !!fascicoloPCT.tipoProcesso){
          console.log('tipoProcesso Deposito impostato a pct.');
          urlIframe = urlIframe + "&tipoProcesso=" + fascicoloPCT.tipoProcesso;
        }
    }
    // console.log("[urlIFrame]",urlIframe);
    return urlIframe;
  }

  static getUrlConsultazionePct(fascicolo: FascicoloLight, pratica: PraticaBase,  user: UtenteLoggato): string {
    let urlIframe = '';
    let indFasc =  fascicoliPCT.findIndex(f => f.idTipoFascicolo === fascicolo.tipoFascicolo.id && f.idTipoPratica === pratica.tipoPratica.id);
    if (indFasc >= 0) {
      let fascicoloPCT: FascicoloPCT = fascicoliPCT[indFasc];
      let fascicoloMap: FascicoloMap = this.getFascicoloMap(fascicolo, pratica);
      if (fascicoloMap) {
        let fascicoloFullResponse: FascicoloFullResponse = <FascicoloFullResponse>callServiceSync(ServicePathsSettings.DOMINIO + fascicoloMap.pathView + '/' + fascicolo.id);
        if (fascicoloFullResponse) {
          let fascicoloFull: FascicoloFull = fascicoloFullResponse.fascicolo;
          let autoritaId = fascicoloFull.autoritaGiudiziaria ? fascicoloFull.autoritaGiudiziaria.id : '';
          let sedeAutoritaId = fascicoloFull.autoritaGiudiziariaCitta ? fascicoloFull.autoritaGiudiziariaCitta.id : '';
          urlIframe = getDominioPctConsultazione() +
              '/' + user.username +
              '/' + fascicoloFull.id +
              '/' + autoritaId +
              '/' + sedeAutoritaId +
              '/' + fascicoloPCT.nomePraticaPCT +
              '/' + fascicoloPCT.nomeFascicoloPCT +
              '/' + Number(fascicoloFull.numeroRuolo) +
              '/' + Number(fascicoloFull.annoRuolo);
        }
      }
    }
    return urlIframe;
  }

  static getFascicoloMap(fascicolo: FascicoloLight, pratica: PraticaBase): FascicoloMap {
    // let nomeFascicoloFE = FrontEndMapping.tipiFascicolo[fascicolo.tipoFascicolo.id];
    // let nomePraticaFE = FrontEndMapping.tipiPratica[pratica.tipoPratica.id];
    return <FascicoloMap>getFascicoloMapSync(pratica.tipoPratica.id, fascicolo.tipoFascicolo.id);
  }
}

